"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app_settings_1 = require("../environments/app-settings");
exports.Settings = app_settings_1.APP_SETTINGS_JSON;
if (exports.Settings.environmentVariables) {
    exports.Settings.environmentVariables.version = __VERSION__;
}
